var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666748 15C0.666748 7.08394 7.084 0.666687 15.0001 0.666687C22.9162 0.666687 29.3334 7.08394 29.3334 15C29.3334 22.9161 22.9162 29.3334 15.0001 29.3334C7.084 29.3334 0.666748 22.9161 0.666748 15ZM15.0001 2.66669C8.18857 2.66669 2.66675 8.18851 2.66675 15C2.66675 21.8115 8.18857 27.3334 15.0001 27.3334C21.8116 27.3334 27.3334 21.8115 27.3334 15C27.3334 8.18851 21.8116 2.66669 15.0001 2.66669Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 11C10.6667 8.6068 12.6069 6.66669 15.0001 6.66669C17.3933 6.66669 19.3334 8.6068 19.3334 11C19.3334 13.3932 17.3933 15.3334 15.0001 15.3334C12.6069 15.3334 10.6667 13.3932 10.6667 11ZM15.0001 8.66669C13.7114 8.66669 12.6667 9.71137 12.6667 11C12.6667 12.2887 13.7114 13.3334 15.0001 13.3334C16.2887 13.3334 17.3334 12.2887 17.3334 11C17.3334 9.71137 16.2887 8.66669 15.0001 8.66669Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3331 19.3334C9.33108 19.3334 6.87364 21.6683 6.67894 24.6205C6.6426 25.1716 6.16639 25.5889 5.6153 25.5525C5.06421 25.5162 4.64693 25.04 4.68328 24.4889C4.94684 20.4925 8.2706 17.3334 12.3331 17.3334H17.6664C21.7236 17.3334 25.044 20.4842 25.3153 24.473C25.3527 25.024 24.9364 25.5011 24.3854 25.5386C23.8344 25.5761 23.3574 25.1598 23.3199 24.6087C23.1195 21.6622 20.6645 19.3334 17.6664 19.3334H12.3331Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.1147d0e2.svg";
export { ForwardRef as ReactComponent };